(() => {
  const qs  = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const dialog = qs("#otumaSearchModal");
  if (!dialog) return;
  if (dialog.dataset.otumaBound === "1") return;
  dialog.dataset.otumaBound = "1";

  const input        = qs("[data-otuma-search-input]", dialog);
  const suggested    = qs("[data-otuma-search-suggested]", dialog);
  const loading      = qs("[data-otuma-search-loading]", dialog);
  const resultsEl    = qs("[data-otuma-search-results]", dialog);
  const resultsList  = qs("[data-otuma-search-list]", dialog);
  const resultsCount = qs("[data-otuma-search-count]", dialog);
  const viewAll      = qs("[data-otuma-search-view-all]", dialog);
  const emptyEl      = qs("[data-otuma-search-empty]", dialog);
  const emptyQuery   = qs("[data-otuma-search-empty-query]", dialog);
  const template     = qs("#otumaSearchProductTemplate");

  const OPEN_MS  = 400;
  const CLOSE_MS = 350;
  const DEBOUNCE = 220;

  let currentFetch = null;
  let debounceTimer = null;

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle("otuma-scroll-lock", lock);
    document.body.classList.toggle("otuma-scroll-lock", lock);
  };

  const isOpen = () => dialog.hasAttribute("open");

  const setState = (state) => {
    qsa("[data-otuma-search-suggested], [data-otuma-search-loading], [data-otuma-search-results], [data-otuma-search-empty]", dialog)
      .forEach(el => el.hidden = true);
    const target = {
      suggested: suggested,
      loading: loading,
      results: resultsEl,
      empty: emptyEl
    }[state];
    if (target) target.hidden = false;
  };

  const openSearch = () => {
    if (isOpen()) return;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "open");
    lockScroll(true);
    setState("suggested");
    requestAnimationFrame(() => {
      dialog.setAttribute("data-state", "open");
      setTimeout(() => input && input.focus(), 80);
    });
  };

  const closeSearch = () => {
    if (!isOpen()) return;
    dialog.setAttribute("data-state", "closed");
    setTimeout(() => {
      try { if (typeof dialog.close === "function") dialog.close(); } catch (_) {}
      dialog.removeAttribute("open");
      dialog.removeAttribute("data-state");
      lockScroll(false);
      if (input) input.value = "";
      setState("suggested");
      if (currentFetch) { currentFetch.abort(); currentFetch = null; }
    }, CLOSE_MS);
  };

  // Open triggers
  qsa("[data-otuma-search-open]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openSearch();
    });
  });

  // Close triggers
  qsa("[data-otuma-search-close]", dialog).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      closeSearch();
    });
  });

  // ESC
  dialog.addEventListener("cancel", (e) => {
    e.preventDefault();
    closeSearch();
  });

  // Suggested term click
  qsa("[data-otuma-search-term]", dialog).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const term = btn.getAttribute("data-otuma-search-term");
      if (input) {
        input.value = term;
        input.focus();
        runSearch(term);
      }
    });
  });

  // Input con debounce
  if (input) {
    input.addEventListener("input", (e) => {
      const q = input.value.trim();
      clearTimeout(debounceTimer);
      if (!q) { setState("suggested"); return; }
      debounceTimer = setTimeout(() => runSearch(q), DEBOUNCE);
    });

    // Enter = ir a página de resultados
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        const q = input.value.trim();
        if (q) {
          closeSearch();
          setTimeout(() => {
            window.location.assign("/search?q=" + encodeURIComponent(q));
          }, CLOSE_MS);
        }
      }
    });
  }

  // Fetch de resultados usando el endpoint predictivo de Shopify
  async function runSearch(q) {
    if (currentFetch) currentFetch.abort();
    const controller = new AbortController();
    currentFetch = controller;

    setState("loading");

    try {
      const url = "/search/suggest.json?q=" + encodeURIComponent(q)
                + "&resources[type]=product"
                + "&resources[limit]=6"
                + "&resources[options][unavailable_products]=last";

      const res = await fetch(url, { signal: controller.signal });
      const data = await res.json();
      var rawProducts = (data.resources && data.resources.results && data.resources.results.products) || [];

      // Filtrar productos ocultos (handle 'topping-extra' o products con tag _hidden si está disponible)
      var HIDDEN_HANDLES = ['topping-extra'];
      const products = rawProducts.filter(function(p) {
        return HIDDEN_HANDLES.indexOf(p.handle) === -1;
      });

      if (products.length === 0) {
        if (emptyQuery) emptyQuery.textContent = q;
        setState("empty");
        return;
      }

      renderResults(products, q);
    } catch (err) {
      if (err.name === "AbortError") return;
      console.error("[otuma-search]", err);
      if (emptyQuery) emptyQuery.textContent = q;
      setState("empty");
    }
  }

  function renderResults(products, q) {
    resultsList.innerHTML = "";

    products.forEach((p) => {
      const node = template.content.cloneNode(true);
      const link = node.querySelector(".otuma-search__result-link");
      const img  = node.querySelector(".otuma-search__result-img img");
      const name = node.querySelector(".otuma-search__result-name");
      const price = node.querySelector(".otuma-search__result-price");

      link.href = p.url;
      name.textContent = p.title;

      if (p.image) {
        img.src = p.image.replace(/(\.[^.]+)$/, "_120x120$1");
        img.alt = p.title;
      } else {
        img.parentElement.style.background = "rgba(33,33,33,0.04)";
      }

      if (p.price) {
        const formatted = formatPrice(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price.textContent = formatted;
        } else {
          price.textContent = formatted;
        }
      }

      // Cerrar modal al clickear resultado
      link.addEventListener("click", (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const href = link.getAttribute("href");
        closeSearch();
        setTimeout(() => window.location.assign(href), CLOSE_MS);
      });

      resultsList.appendChild(node);
    });

    if (resultsCount) {
      resultsCount.textContent = products.length + " resultado" + (products.length === 1 ? "" : "s");
    }

    if (viewAll) {
      viewAll.href = "/search?q=" + encodeURIComponent(q);
    }

    setState("results");
  }

  function formatPrice(cents) {
    const num = typeof cents === "string" ? parseFloat(cents) : cents;
    const amount = num > 1000 ? num / 100 : num;
    return "$" + amount.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
})();